/* eslint-disable @typescript-eslint/no-explicit-any */
import { Badge } from "@/components/ui/badge";
import { SwitchRenderer } from "@/components/shared/switch-renderer";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { format } from "date-fns";

export const EmailStatsTableCell = ({ header, value }: any) => {
  switch (header) {
    case "status": {
      return (
        <SwitchRenderer
          type={value}
          components={{
            read: (
              <span className="text-green-500 bg-green-50 py-1 border-green-100 border px-3 rounded-[50px] inline-block">
                {value}
              </span>
            ),
            success: (
              <span className="text-green-500 bg-green-50 py-1 border-green-100 border px-3 rounded-[50px] inline-block">
                {value}
              </span>
            ),
            failed: (
              <span className="text-red-500 bg-red-50 py-1 border border-red-100 px-3 rounded-[50px] inline-block">
                {value}
              </span>
            ),
            error: (
              <span className="text-red-500 bg-red-50 py-1 border border-red-100 px-3 rounded-[50px] inline-block">
                {value}
              </span>
            ),
            default: <Badge variant={"outline"}>{value}</Badge>,
          }}
        />
      );
    }
    case "received_at":
    case "read_time": {
      if (!value) return <span>-</span>;
      try {
        const formattedDate = format(new Date(value), "dd-MM-yyyy hh:mm a");
        return <span>{formattedDate}</span>;
      } catch {
        return <span>{value}</span>;
      }
    }
    case "body_content": {
      if (value === true || value === "true") return <span>Yes</span>;
      if (value === false || value === "false") return <span>No</span>;
      return <span>-</span>;
    }
    case "ignored_reasons": {
      if (!value || (Array.isArray(value) && value.length === 0))
        return <span>-</span>;
      const text = Array.isArray(value) ? value.join(", ") : String(value);
      return (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger className="text-left line-clamp-1">
              {text}
            </TooltipTrigger>
            <TooltipContent>
              <TooltipArrow />
              <p>{text}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }
    case "sender_email":
    case "subject": {
      if (!value) return <span>-</span>;
      return (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger className="text-left line-clamp-1">
              {value}
            </TooltipTrigger>
            <TooltipContent>
              <TooltipArrow />
              <p>{value}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }
    default: {
      if (value === undefined || value === null || value === "")
        return <span>-</span>;
      return <span>{String(value)}</span>;
    }
  }
};
